<div class="container">
 <ng-container *ngIf="loading; then loadingView else licenseView"></ng-container>
</div>

<ng-template #loadingView>
  <div class="page-spinner">
    <mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner>
  </div>
</ng-template>

<ng-template #licenseView>
  <div [innerHtml]="content" class="mt-5"></div>
</ng-template>
